import React, { VFC } from 'react';
import T from 'i18n-react';
import styled from 'styled-components';
import { Theme } from '@material-ui/core/styles';
import { getTotalWorkingHours } from '../utils';
import { useTheme } from '@material-ui/styles';

const P = styled.p<{ theme: Theme }>`
  margin: ${({ theme }) => theme.spacing(0.5, 0, 0)};
`;
const Notice = styled(P)`
  font-size: 14px;
`;

interface Props {
  totalTimes: string;
  workingDays: number;
}

const MoneyDescription: VFC<Props> = ({ totalTimes, workingDays }: Props) => {
  const theme = useTheme();
  const totalWorkingHours = getTotalWorkingHours(totalTimes, workingDays);

  return (
    <>
      <P theme={theme}>
        {T.translate('planPage.planTerms.moneyDescription', {
          totalWorkingHours,
        })}
      </P>
      <Notice theme={theme}>
        {T.translate('planPage.planTerms.moneyNoticeDescription')}
      </Notice>
    </>
  );
};

export default MoneyDescription;
